module.exports = [{"type":"title","text":"2024-07-30"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"USDT-M Perp Futures: All market data APIs and websocket DataTypes support USDC contracts."},{"type":"html","text":"NEW : /openApi/swap/v3/user/balance  return both USDT and USDC"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-07-30.json
// module id = OTiI
// module chunks = 3